import WindowAccessories from "./WindowAccessories";

export default WindowAccessories;